
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DistrictDialogBoxComponent } from '../district-dialog-box/district-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { log } from 'console';

@Component({
  selector: 'app-district-data',
  templateUrl: './district-data.component.html',
  styleUrls: ['./district-data.component.scss']
})
export class DistrictDataComponent implements OnInit {
  displayColumns = [ 'DistrictCode', 'DistrictName'];
  showpdfbtn=false;
  showcsvbtn=false;
  bydefaultbtn=true
  DistrictForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  showBtn=false;
  showBtn1=false;
  districtList: any;
  DsCode: any;
  DsName: any;
  isreadonlydel = false;
  isReadOnlyCode = false;
  district: string;
  list;
  districtform: any;
  DistrictSearchForm;
  APIService: any;
  deleteButton: boolean;
  DsCodefordelete;
  isreadonly = true;
  dialogRef: MatDialogRef<any>;
  userPermission:any;
  utp: any;
  DisCreate = true;
DisUpdate = true;
DisDelete = true;
pageSize = 10;
pageSizeOptions: number[] = [5, 10, 20];
currentPage = 1;
totalItems = 0;
sortedData: any[];
sortColumn: string = '';  // Track the currently sorted column
sortDirection: string = 'asc';
  SessionNo: any;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog:MatDialog,
              private fb: FormBuilder,   public router: Router, private httpClient: HttpClient,
              private route: ActivatedRoute, private spinner:NgxSpinnerService, ) {this.APIService = environment.serviceUrl; }
 

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.getDistrictData();
    this.list = true;
    this.DistrictSearchForm = this.fb.group({
      SearchString: new FormControl ('')
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }
  
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    // const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getDistrictData();
  }

  getDistrictData() {
 this.spinner.show();
        const payload = {};
        payload['PageSize'] = this.pageSize;
        payload['PageNumber'] = this.currentPage;
        this.umsService.getDistrict(payload).subscribe(res => {
          this.spinner.hide();
      this.districtList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    }, (ERROR: HttpErrorResponse) => {
      this.districtList = [];
      let  data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);

   });
  }
  
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.districtList = [];
      let payload = {}
      payload['SearchString'] = this.DistrictSearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchDistrict(payload).subscribe(res => {
        if(res.status){
          this.districtList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.districtList = [];
          this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.districtList = [];
      });
    },1000)
   
  }

  redirect(to): void {
    this.router.navigate([to]);
   }

   download(){
    this.showBtn=false;
    this.showBtn1=true;
    const wwe = ['DsCode', 'DsName'];
    this.umsService.downloadFile(this.districtList, 'jsontocsv', wwe);
  }
   globalPrint(){
    this.showBtn=true;
    this.showBtn1=false;
    let currentDate =new Date();
    let date=currentDate.toLocaleDateString('en-GB');
    let titleName='District Form.pdf'+date
    var tempTitle = document.title;
    document.title = titleName;
    window.print();
    document.title = tempTitle;
   }
   clickCSV(){
    this.showcsvbtn=true;
    this.showpdfbtn=false;
    this.bydefaultbtn=false;
    // this.download();
   }
   clickPDF(){
    this.showpdfbtn=true;
    this.showcsvbtn=false;
    this.bydefaultbtn=false;
    // this.globalPrint();
   }
   addnewrecord() {
    const dialogRef = this.dialog.open(DistrictDialogBoxComponent, {
      width: '80vh',
      data: {key : "New"},
      disableClose: true 
    }); 
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getDistrictData();
      this.DistrictSearchForm.controls['SearchString'].setValue('');
    });
  }
  editData(k){
    const dialogRef = this.dialog.open(DistrictDialogBoxComponent, {
      width: '80vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
        this.getDistrictData();
        this.DistrictSearchForm.controls['SearchString'].setValue('');
    });
  }
  deleteData(k){
    const dialogRef = this.dialog.open(DistrictDialogBoxComponent, {
      width: '80vh',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
        this.getDistrictData();
        this.DistrictSearchForm.controls['SearchString'].setValue('');
    });
  }

  Print(){
    let submitpayload = this.DistrictSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-District';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 113,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

}
